import axios from "axios";

let port = window.location.port === "3000" ? 4001 : window.location.port;
const instance = axios.create({
	baseURL: `//${window.location.hostname}:${port}`,
});

export const hideAll = async (projectId) => {
	try {
		return await instance
			.post(`/h2r-graphics/${projectId}/clear`)
			.then(function (response) {
				// handle success

				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}
};

export const addProject = async () => {
	try {
		return await instance
			.post(`/h2r-graphics/project/add`)
			.then(function (response) {
				// handle success

				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}
};

export const renameProject = async (projectId, name) => {
	try {
		return await instance
			.post(`/h2r-graphics/project/${projectId}/rename`, {name})
			.then(function (response) {
				// handle success

				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}
};

export const updateProject = async (projectId, update) => {
	try {
		return await instance
			.post(`/h2r-graphics/project/${projectId}/update`, {...update})
			.then(function (response) {
				// handle success

				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}
};

export const addCue = async (
	type,
	projectId,
	object = {},
	bringDirectlyOnAir = false
) => {
	try {
		return await instance
			.post(
				"/h2r-graphics/cue/new",
				{ type, projectId, object}
			)
			.then(function (response) {
				// handle success
				if (bringDirectlyOnAir) {
					updateCue(response.data.id, projectId, { status: "offair" });
					setTimeout(() => {
						updateCue(response.data.id, projectId, { status: "coming" });
					}, 100);
				}
				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}
};

export const updateCue = (id, projectId, update) => {
	try {
	 instance.post(
		 `/h2r-graphics/${projectId}/updateCue/${id}`,
		 { update, updatedAt: Date.now() },
		)
	} catch (error) {
	 console.error(error)
	}
 }

export const updateScore = (id, projectId, team, score, update) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/updateScore/${id}/${team}/${score}`,
			{ update }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateScoreLevel = (id, projectId, update) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/updateScore/${id}`,
			{ update }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const duplicateCue = (id, projectId) => {
	instance
		.post(`/h2r-graphics/${projectId}/duplicateCue/${id}`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const reorderCue = (projectId, id, oldIndex, newIndex) => {
	instance
		.post(
			`/h2r-graphics/cue/reorder/${projectId}/${id}`,
			{ id, oldIndex, newIndex }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const removeCue = (id, projectId) => {
	instance
		.delete(`/h2r-graphics/cue/delete/${projectId}/${id}`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const resetCues = (projectId) => {
	instance
		.post(`/h2r-graphics/project/${projectId}/updateCues`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const runCues = (projectId) => {
	instance
		.post(`/h2r-graphics/project/${projectId}/run`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const changeTheme = (projectId, themeId) => {
	instance
		.post(`/h2r-graphics/project/${projectId}/changeTheme/${themeId}`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const renameTheme = (projectId, themeName, newName) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/theme/${themeName}/rename`,
			{ newName }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateTheme = (projectId, themeName, section, element, change) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/theme/${themeName}/update`,
			{ section, element, change }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const deleteTheme = (projectId, themeName) => {
	instance
		.post(`/h2r-graphics/${projectId}/theme/${themeName}/delete`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const duplicateTheme = async (projectId, themeName, newName) => {
	return await instance
		.post(
			`/h2r-graphics/${projectId}/theme/${themeName}/duplicate`,
			{ newName }
		)
		.then(function (response) {
			// handle success
			return response;
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		});
};

// export const addThemePreset = (themeName, graphic, name) => {
// 	instance
// 		.post(
// 			`/h2r-graphics/theme/${themeName}/addPreset`,
// 			`graphic=${graphic}&name=${name}`
// 		)
// 		.then(function (response) {
// 			// handle success
// console.log(response);
// 		})
// 		.catch(function (error) {
// 			// handle error
// 			console.log(error);
// 		})
// 		.then(function () {
// 			// always executed
// 		});
// };

// export const removeThemePreset = (themeName, graphic, presetId) => {
// 	instance
// 		.post(
// 			`/h2r-graphics/theme/${themeName}/removePreset`,
// 			`graphic=${graphic}&presetId=${presetId}`
// 		)
// 		.then(function (response) {
// 			// handle success
// console.log(response);
// 		})
// 		.catch(function (error) {
// 			// handle error
// 			console.log(error);
// 		})
// 		.then(function () {
// 			// always executed
// 		});
// };

export const updateThemeOverride = (
	projectId,
	themeName,
	graphic,
	element,
	change
) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/theme/${themeName}/updateOverride`,
			{ graphic, element, change }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const removeThemeOverride = (
	themeName,
	graphic,
	preset,
	section,
	element
) => {
	instance
		.post(
			`/h2r-graphics/theme/${themeName}/removeOverride`,
			{ graphic, preset, section, element }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const addDataSource = (project, id, type, details) => {
	console.log('addDataSource', project, id, type, details)
	instance
		.post(
			`/h2r-graphics/data/${project}/add`,
			{ id, type, details: details }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const connectToDataSource = (id, dataSourceType) => {
	instance
		.post(
			`/h2r-graphics/data/${id}/connect`,
			{ dataSourceType }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const removeDataSource = (id) => {
	instance
		.post(`/h2r-graphics/data/${id}/remove`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const listDataSourceMessage = (id, messageId, update) => {
	instance
		.post(
			`/h2r-graphics/data/${id}/updateItem`,
			{ messageId, update }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const addDataSourceMessage = (id, message) => {
	console.log("running");
	instance
		.post(
			`h2r-graphics/data/${id}/addMessage`,
			{ message }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const removeDataSourceMessages = ([id]) => {
	instance
		.post(
			`h2r-graphics/data/${id}/clearAll`,
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const importFile = async (id, file) => {
	try {
		return await instance
			.post(`/h2r-graphics/media/${id}/import`, file, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (response) {
				// handle success
				return response;
			})
			.catch(function (error) {
				// handle error
				return error;
			});
	} catch (error) {
		console.error(error);
	}
};

export const importFileSequence = async (id, files, partOf, firstFile) => {
	try {
		return await instance
			.post(`/h2r-graphics/media/${id}/import-sequence/${partOf}/${firstFile}`, files, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (response) {
				// handle success
				return response;
			})
			.catch(function (error) {
				// handle error
				return error;
			});
	} catch (error) {
		console.error(error);
	}
};

export const removeFile = (id, fileName) => {
	instance
		.post(`/h2r-graphics/media/${id}/remove/${fileName}`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateMediaFile = (id, filename, update) => {
	instance
		.post(`/h2r-graphics/media/${id}/update/${filename}`, update)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateDynamicText = (id, dynamicTextId, text) => {
	instance
		.post(
			`h2r-graphics/${id}/updateDynamicText/${dynamicTextId}`,
			{ text: text }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateDynamicTexts = (id, dynamicTextObject) => {
	instance
		.post(
			`h2r-graphics/${id}/updateDynamicTexts`,
			{ dynamicTextObject }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const addDynamicList = (id) => {
	instance
		.post(`h2r-graphics/${id}/dynamicList/add`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};
export const removeDynamicList = (id, listIndex) => {
	instance
		.post(`h2r-graphics/${id}/dynamicList/${listIndex}/remove`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const reorderListRow = (projectId, listIndex, oldIndex, newIndex) => {
	instance
		.post(
			`/h2r-graphics/${projectId}/dynamicList/${listIndex}/reorder`,
			{ oldIndex, newIndex }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateDynamicListSelectedRow = async (
	id,
	listIndex,
	selectedRow
) => {
	try {
		return await instance
			.post(
				`h2r-graphics/${id}/dynamicList/${listIndex}/selectRow/${selectedRow}`
			)
			.then(function (response) {
				// handle success
				console.log(response);
				return response;
			})
			.catch(function (error) {
				// handle error
				console.log(error);
			});
	} catch (error) {
		console.error(error);
	}

	// const res = await instance
	// 	.post(
	// 		`h2r-graphics/${id}/dynamicList/${listIndex}/selectRow/${selectedRow}`
	// 	)
	// 	.then(function (response) {
	// 		// handle success
	// 		// console.log(response);
	// 	})
	// 	.catch(function (error) {
	// 		// handle error
	// 		console.log(error);
	// 	})
	// 	.then(function () {
	// 		// always executed
	// 	});

	// console.log(res);
};

export const updateDynamicListRemoveRow = (id, listIndex, rowIndex) => {
	console.log("updateDynamicListRemoveRow", id, listIndex, rowIndex);
	instance
		.post(`h2r-graphics/${id}/dynamicList/${listIndex}/removeRow/${rowIndex}`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateDynamicListCell = (
	id,
	listIndex,
	rowIndex,
	cellIndex,
	text
) => {
	instance
		.post(
			`h2r-graphics/${id}/dynamicList/${listIndex}/updateCell/${rowIndex}/${cellIndex}`,
			{ text: text }
		)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const updateDynamicListAddRow = (id, listIndex) => {
	instance
		.post(`h2r-graphics/${id}/dynamicList/${listIndex}/addRow`)
		.then(function (response) {
			// handle success
			// console.log(response);
		})
		.catch(function (error) {
			// handle error
			console.log(error);
		})
		.then(function () {
			// always executed
		});
};

export const addLicenceKey = async (key) => {
	const res = await instance
		.post(`h2r-graphics/key/add`, { key })
		.then(function (response) {
			// handle success
			return response;
		})
		.catch(function (error) {
			// handle error
			return error;
		});

	return res;
};

export const removeLicenceKey = async (key) => {
	const res = await instance
		.post(`h2r-graphics/key/remove`, { key })
		.then(function (response) {
			// handle success
			return response;
		})
		.catch(function (error) {
			// handle error
			return error;
		});

	return res;
};